<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-07-26 19:11:19
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>供应商管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="供应商名称" prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="请输入供应商名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="服务地址" prop="url">
              <el-input
                v-model="ruleForm1.url"
                placeholder="请输入服务地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="服务分类" prop="type">
              <el-select
                v-model="ruleForm1.type"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.creatorId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务省" prop="type1">
              <el-select
                v-model="ruleForm1.type1"
                placeholder="请选择"
                style="margin-right: auto"
                @change="cityChange"
              >
                <el-option
                  v-for="(item, index) in city"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="服务城市"
              prop="select"
              v-if="ruleForm1.type1 != '100000'"
            >
              <el-select
                v-model="ruleForm1.select"
                placeholder="请选择"
                style="margin-right: auto"
                @change="cityChange1"
              >
                <el-option
                  v-for="(item, index) in city1"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="服务地区"
              prop="send"
              v-if="ruleForm1.type1 != '100000'"
            >
              <el-select
                v-model="ruleForm1.send"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option
                  v-for="(item, index) in city2"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="公司地址" prop="address">
              <el-input
                v-model="ruleForm1.address"
                placeholder="请输入公司地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="客服电话" prop="tel">
              <el-input
                v-model="ruleForm1.tel"
                placeholder="请输入客服电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="微信公众号" prop="weixin">
              <el-input
                v-model="ruleForm1.weixin"
                placeholder="请输入微信公众号"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button @click="resetForm1('ruleForm')">取消</el-button>
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增供应商",
      ruleForm1: {
        name: "",
        url: "",
        type: "",
        type1: "",
        send: "",
        select: "",
        address: "",
        tel: "",
        weixin: "",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        type1: [{ required: true, message: "必选项", trigger: "change" }],
        send: [{ required: true, message: "必选项", trigger: "change" }],
        tel: [{ required: true, message: "必填项", trigger: "blur" }],
        select: [{ required: true, message: "必选项", trigger: "change" }],
        weixin: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        url: [{ required: true, message: "必填项", trigger: "blur" }],
        address: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      options: [],
      editId: "",
      city: [],
      city1: [],
      city2: [],
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑供应商";
      this.getDetail();
    }
    this.getcity();
    this.getcategry();
  },
  methods: {
    cityChange() {
      if (this.ruleForm1.type1 != "" && this.ruleForm1.type1 != "0") {
        this.getcity1();
      }
    },
    cityChange1() {
      if (this.ruleForm1.type1 != "" && this.ruleForm1.type1 != "0") {
        this.getcity2();
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.goBack();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.ruleForm1.name,
            address: this.ruleForm1.url,
            categoryId: this.ruleForm1.type,
            provinceCode: this.ruleForm1.type1,
            cityCode: this.ruleForm1.select,
            areaCde: this.ruleForm1.send,
            phone: this.ruleForm1.tel,
            wechatOfficial: this.ruleForm1.weixin,
            companyAdress: this.ruleForm1.address,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/supplier/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally();
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/supplier/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.editId = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/supplier/get/${this.editId}`)
        .then(({ data }) => {
          console.log(data);
          this.ruleForm1.name = data.name;
          this.ruleForm1.url = data.address;
          this.ruleForm1.type = data.categoryId;
          this.ruleForm1.type1 = data.provinceCode;
          this.ruleForm1.select = data.cityCode;
          this.ruleForm1.send = data.areaCde;
          this.ruleForm1.address = data.companyAdress;
          this.ruleForm1.tel = data.phone;
          this.ruleForm1.weixin = data.wechatOfficial;
        })
        .catch()
        .finally();
    },
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let obj = {
            name: "全国",
            adcode: "100000",
          };
          data.unshift(obj);
          this.city = data;
          if (this.ruleForm1.type1 != "") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm1.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
          if (this.ruleForm1.select != "") {
            this.getcity2();
          }
        })
        .catch()
        .finally();
    },
    getcity2() {
      let param = {
        type: 2,
        adcode: this.ruleForm1.select,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city2 = data;
        })
        .catch()
        .finally();
    },
    getcategry() {
      let param = {
        queryParams: [
          {
            name: "page_module",
            type: "select",
            values: [
              {
                itemKey: 4,
              },
            ],
          },
        ],
      };
      this.$axios
        .post(`admapi/categories/getCategoriesByModule`, param)
        .then(({ data }) => {
          this.options = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
